import { renderToString } from 'react-dom/server';
import type { ComponentClass, FunctionComponent, PropsWithChildren, ReactElement } from 'react';
import { createElement, isValidElement } from 'react';

function elementToString(el: ReactElement): string;
function elementToString<P extends PropsWithChildren<unknown>>(
  el: FunctionComponent<P> | ComponentClass<P>,
  props?: P,
): string;
function elementToString<P extends PropsWithChildren<unknown>>(
  el: FunctionComponent<P> | ComponentClass<P> | ReactElement,
  props?: P,
) {
  if (isValidElement(el)) {
    return renderToString(el);
  }

  return renderToString(createElement(el, props));
}

export { elementToString };
